var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questions-page" },
    [
      _c("progressbar", { attrs: { progressbar: _vm.data.progressbar } }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c("div", { staticClass: "col-lg-10" }, [
          _c("h1", { staticClass: "mb-4" }, [_vm._v(_vm._s(_vm.selectedName))])
        ])
      ]),
      !_vm.isLoaded ? _c("loader") : _vm._e(),
      _vm._l(_vm.data.viewedQuestions, function(model, index) {
        return index == 0 || _vm.data.viewedQuestions[index - 1].isEnableNext
          ? _c(model.type, {
              tag: "model",
              attrs: { model: model, refresh: _vm.data.r },
              on: { selectedQuestionValue: _vm.onSelectedQuestionValue }
            })
          : _vm._e()
      }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c("div", { staticClass: "col-lg-10" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c(
                "button",
                {
                  staticClass: "button type-15 transparent",
                  attrs: { id: "backToStep0" },
                  on: {
                    click: function($event) {
                      return _vm.onBackToCalcSelector(-1)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("keyboard_backspace")
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.trans("navigation_back")) +
                      "\n                "
                  )
                ]
              ),
              _c(
                "button",
                {
                  class: [
                    "button type-2 ml-auto",
                    _vm.isEnableNextButton ? "" : "disabled"
                  ],
                  attrs: { id: "toStep2" },
                  on: { click: this.enableNextComponent }
                },
                [_vm._v(_vm._s(_vm.trans("navigation_next")))]
              )
            ]
          )
        ]),
        _c("div", { staticClass: "col-lg-1" })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }